"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "BulkImport___StyledSvg",
  componentId: "sc-115ph4t-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function BulkImport(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4 2a5.567 5.567 0 00-5.15 3.402A3.966 3.966 0 006 5.2c-2.206 0-4 1.794-4 4a4.006 4.006 0 003.2 3.92v-1.668A2.395 2.395 0 013.6 9.2c0-1.323 1.077-2.4 2.4-2.4.456 0 .904.134 1.294.385a.8.8 0 001.213-.491A3.979 3.979 0 0112.4 3.6c2.206 0 4 1.794 4 4a3.984 3.984 0 01-1.6 3.18v1.872A5.602 5.602 0 0018 7.6C18 4.512 15.488 2 12.4 2z",
    fill: "currentColor"
  }), _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.766 11.834L10 8.07l-3.766 3.765 1.132 1.132L9.2 11.13V18h1.6v-6.869l1.834 1.835 1.132-1.132z",
    fill: "currentColor"
  }));
}

var _default = BulkImport;
exports["default"] = _default;